module.exports = __webpack_public_path__ + "img/johnny_headshot.c3ac153a.png";